<div class="collapsable-container">
  <div class="collapsable-container-header" (click)="toggleCollapse()">
      <span class="btn-collapse" (click)="toggleCollapse()"><span class="fa fa-fw fa-angle-double-down"></span></span>
      <div class="heading">{{ 'DOKUMENTSTAVKE.SINGULAR' | translate }}</div>
  </div>
  <div class="collapsable-container-content" [ngClass]="{'collapsed': collapsed}">
  <yt-fin-dokument-stavka-update #baseUpdate></yt-fin-dokument-stavka-update>
      <div class="row">
          <div class="col-md-12">
              <div class="btn-group float-right">
                  <button type="button" class="btn btn-outline-primary" (click)="Save()"><span class="fa fa-fa fa-save"></span></button>
                  <button type="button" class="btn btn-outline-primary"><span>Zatvori</span></button>
              </div>
          </div>
      </div>
  </div>
</div>